import {
  ACTION_TYPES,
  DIALOGS,
  LAYOUT_TYPES,
  TABS,
  THEMES
} from '~/core/constants'

const { UI, SETTINGS } = ACTION_TYPES

const initialState = {
  dialog: DIALOGS.NONE,
  dialogProps: {},
  isFullScreen: false,
  joinButtonDisabled: false,
  layoutType: LAYOUT_TYPES.WIDE,
  meetingsTab: TABS.UPCOMING,
  showUpcomingPanel: true,
  roomInputHasError: false,
  systemTheme: THEMES.LIGHT,
  theme: THEMES.LIGHT,
  viewedSessionId: null,
  visibleScreens: [],
  windowSize: {
    windowWidth: window.width,
    windowHeight: window.height
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UI.SET_MEETINGS_TAB: {
      const updatedState = {
        ...state,
        meetingsTab: action.payload
      }

      return updatedState
    }
    case UI.SET_VIEWED_SESSION: {
      return {
        ...state,
        viewedSessionId: action.payload
      }
    }
    case UI.SET_DIALOG: {
      const { dialog, props: dialogProps } = action.payload

      return {
        ...state,
        dialog,
        dialogProps
      }
    }
    case UI.SET_ROOM_INPUT_ERROR: {
      return {
        ...state,
        roomInputHasError: action.payload
      }
    }
    case UI.SET_JOIN_BUTTON_DISABLED: {
      return {
        ...state,
        joinButtonDisabled: action.payload
      }
    }
    case UI.ADD_VISIBLE_SCREEN: {
      return {
        ...state,
        visibleScreens: [
          ...state.visibleScreens.filter(s => s !== action.payload),
          action.payload
        ]
      }
    }
    case UI.REMOVE_VISIBLE_SCREEN: {
      return {
        ...state,
        visibleScreens: state.visibleScreens.filter(s => s !== action.payload)
      }
    }
    case UI.SET_LAYOUT_TYPE: {
      return {
        ...state,
        layoutType: action.payload
      }
    }
    case UI.SET_FULL_SCREEN: {
      return {
        ...state,
        isFullScreen: action.payload
      }
    }
    case UI.SET_THEME:
      return {
        ...state,
        theme: action.payload
      }
    case SETTINGS.SET_CONFERENCE_SETTINGS:
      if (action.payload.hideUpcoming) {
        return {
          ...state,
          meetingsTab: TABS.RECENT
        }
      }
      return state
    case UI.SET_WINDOW_SIZE:
      return {
        ...state,
        windowSize: action.payload
      }
    case UI.SET_SHOW_UPCOMING_PANEL:
      return {
        ...state,
        showUpcomingPanel: action.payload
      }
    default:
      return state
  }
}

export default reducer
